// extracted by mini-css-extract-plugin
export default {"eventBindInfo":"EventBindInformation_eventBindInfo__0OeLS"};